/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SignFieldCheckBox16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13.436 0c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v10.873c0 .892-.093 1.215-.267 1.54-.174.327-.43.583-.756.757-.326.174-.65.267-1.54.267H2.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 01-.757-.756C.093 14.65 0 14.327 0 13.437V2.563c0-.892.093-1.215.267-1.54.174-.327.43-.583.756-.757C1.35.093 1.673 0 2.563 0h10.873zm-1.878 3.5a.888.888 0 00-.461.113c-.127.075-.247.206-.36.392l-3.71 6.114-1.863-2.34a.89.89 0 00-.727-.357.897.897 0 00-.671.273.948.948 0 00-.266.689c0 .122.02.239.06.35.04.11.112.226.216.349L6.21 12.1c.22.267.498.4.832.4.38 0 .67-.15.867-.452l4.39-6.955c.07-.112.12-.222.152-.329a1.08 1.08 0 00.048-.307.937.937 0 00-.268-.684.905.905 0 00-.674-.273z"
        />
    </AccessibleSVG>
);

export default SignFieldCheckBox16;
